import { render, staticRenderFns } from "./CurrentLpo__taxAccordanceComparison.vue?vue&type=template&id=d70811ec&scoped=true&"
import script from "./CurrentLpo__taxAccordanceComparison.vue?vue&type=script&lang=js&"
export * from "./CurrentLpo__taxAccordanceComparison.vue?vue&type=script&lang=js&"
import style0 from "@/style/table.css?vue&type=style&index=0&id=d70811ec&scoped=true&lang=css&"
import style1 from "./CurrentLpo__taxAccordanceComparison.vue?vue&type=style&index=1&id=d70811ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d70811ec",
  null
  
)

export default component.exports